import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { IndexPage } from "./modules";
import { useLocalizationStore } from "@/shared";

const routes: Array<RouteRecordRaw> = [IndexPage];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    let position = {}
    if (savedPosition) {
      position = savedPosition
    }
    else if (to.hash) {      
      position = { el: to.hash , top: 170};      
    }
    // return position;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
          resolve(position)
      }, 1000)
    })
  }
});

router.beforeEach(async (to, from, next) => {
  const locStore = useLocalizationStore();
  /** Получаем текущий язык из куков */
  locStore.getLocal();

  if (!locStore.isInited) {
    await locStore.init();
  }

  next();
  return;
});
export * from "./modules";
export default router;
